/* eslint-disable react/prop-types */
import { useEffect, useMemo, useState } from "react";

import { strCode } from "../../../../../../../consts";
import { t } from "../../../../../../../services";
import { useFocusOnInput } from "../../../../../../../hooks";

import {
  EditButtonsGroup,
  FlexContainers,
  IconButton,
  Input,
  SVG,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../../../../../components";
import { CellWrapper } from "../../../../../../../components/Table/styled";

export const CustomFeaturesModalTableColumns = [
  {
    Header: strCode.NAME_TITLE,
    accessor: "name",
    Cell: ({
      cell,
      callbackFn1: getEditingCustomFeature,
      callbackFn4: setEditingCustomFeature
    }) => {
      const [name, setName] = useState("");

      const isEditing = useMemo(() => {
        return !!cell.row.original.isEdit;
      }, [cell]);

      const onNameChange = (newName) => {
        setName(newName);
        setEditingCustomFeature((prev) => ({ ...prev, name: newName }));
      };

      const inputRef = useFocusOnInput(isEditing);

      useEffect(() => {
        if (isEditing) {
          setName(getEditingCustomFeature().name);
        }
      }, [isEditing]);

      return (
        <CellWrapper width="180px">
          <WrapperContainer>
            {isEditing ? (
              <WrapperContainer width={180}>
                <Input
                  id={`${cell.row.original.name}-input`}
                  placeholder={t(strCode.ENTER_NAME_PLACEHOLDER)}
                  value={name}
                  setValue={onNameChange}
                  isSmall
                  innerRef={inputRef}
                />
              </WrapperContainer>
            ) : (
              <TextOverflowWrapper maxWidth="180px">{cell.value}</TextOverflowWrapper>
            )}
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.VALUE_TITLE,
    accessor: "value",
    Cell: ({
      cell,
      callbackFn1: getEditingCustomFeature,
      callbackFn2: onSaveCustomFeatureEditing,
      callbackFn3: onCancelCustomFeatureEditing,
      callbackFn4: setEditingCustomFeature,
      callbackFn5: onDeleteCustomFeature,
      callbackFn6: onSetEditingCustomFeature
    }) => {
      const [value, setValue] = useState("");

      const isEditing = useMemo(() => {
        return !!cell.row.original.isEdit;
      }, [cell]);

      const isCustomFeatureValid = useMemo(() => {
        const editingFeature = getEditingCustomFeature();

        return !!editingFeature?.name && !!editingFeature?.value;
      }, [getEditingCustomFeature]);

      const onValueChange = (newValue) => {
        setValue(newValue);
        setEditingCustomFeature((prev) => ({ ...prev, value: newValue }));
      };

      useEffect(() => {
        if (isEditing) {
          setValue(getEditingCustomFeature().value);
        }
      }, [isEditing]);

      return (
        <CellWrapper width="100%" minWidth="454px">
          <WrapperContainer Container={FlexContainers.FlexRowBetween} width="100%">
            <WrapperContainer width="100%" maxWidth={360}>
              {isEditing ? (
                <Input
                  id={`${cell.row.original.value}-input`}
                  placeholder={t(strCode.ENTER_VALUE_PLACEHOLDER)}
                  value={value}
                  setValue={onValueChange}
                  isSmall
                />
              ) : (
                <TextOverflowWrapper>{cell.value}</TextOverflowWrapper>
              )}
            </WrapperContainer>

            <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={16}>
              {!isEditing && (
                <IconButton onClick={() => onDeleteCustomFeature(cell.row.original.name)}>
                  <SVG.DeleteIcon />
                </IconButton>
              )}

              <WrapperContainer>
                <EditButtonsGroup
                  handleCancel={onCancelCustomFeatureEditing}
                  handleAccept={onSaveCustomFeatureEditing}
                  handleEdit={() => onSetEditingCustomFeature(cell.row.original)}
                  isEdit={!isEditing}
                  disableAccept={!isCustomFeatureValid}
                />
              </WrapperContainer>
            </WrapperContainer>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
